<template>
  <div style="display: flex">
    <div style="width: 108px; height: 46px">
      <dv-digital-flop :config="config" />
    </div>
    <div style="height: 46px; padding: 5px 0 0 5px">
      <span style="font-size: 13px; color: #dfb6b6">
        {{ current.name }}
      </span>
      <br />
      <span style="color: #9f9f9f; font-size: 11px">{{ current.unit }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['items'],
  data() {
    return {
      step: 0,
      name: '',
      unit: '',
      timer: null,
    }
  },
  computed: {
    current() {
      return this.items[this.step & 1]
    },
    config() {
      const { val } = this.current
      const str = val.toString()
      return {
        number: [val],
        textAlign: 'right',
        style: {
          fontSize: 42,
          fill: '#fc669b',
        },
        toFixed: str.indexOf('.') > 0 ? str.split('.')[1].length : 0,
      }
    },
  },
  mounted() {
    const $this = this
    this.timer = setInterval(() => {
      $this.step++
    }, 5000)
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen38496/summary-zone/digi-flopper.vue